import styled from 'styled-components';
import { LayoutDashboardLeftMenuButtonStyle } from '../../LayoutDashboardLeftMenu.style';
import { colourPalette, padding } from 'styles/styles';
import { PButton } from 'components/prime/PButton/PButton';
import { VStack } from 'components/layouts/primitives/Stack/Stack';

export const LayoutDashboardLeftMenuUserStyle = {
  Container: styled.div`
    .p-menu-overlay {
      transform: translateX(calc(100% + 2px));
      margin-top: 44px;
      min-width: 260px;
    }
  `,
  Button: styled(PButton)`
    ${LayoutDashboardLeftMenuButtonStyle}
    .button-custom-wrapper {
      width: 100%;
    }
    .button-custom-label {
      color: ${colourPalette.neutral900} !important;
      padding-left: ${padding.paddingMD};
    }
    &:hover {
      svg path,
      svg g path {
        stroke: ${colourPalette.neutral400} !important;
      }
    }
  `,
  MenuItem: styled(VStack)`
    padding: ${padding.paddingMD} 0;
  `,
};
